<section>
  <h3>{{ 'data_privacy_notice_title' | translate }}</h3>
  <p class="account-policy-terms-paragraph ods-typography-body-s-regular">
    {{ 'read_in_detail_the_personal_data_protection_notice' | translate }}
    <a [attr.href]="boxDpnUrl" target="_blank">{{ 'here_' | translate }}</a>.
  </p>
</section>
